import { getS3FileByFileName } from 'services'

export const handleDownload = (filename: string): void => {
  getS3FileByFileName(filename)
    .then(res => window.open(res, '_blank'))
    .catch(err => console.error(err))
}
